import { Image } from '@/components/Image';

interface IProps {
  title: string;
  desc?: string;
  isShippingAvailable: boolean;
  onClick: () => void;
}

export default function OrderPageHeaderSection({ title, desc, isShippingAvailable, onClick }: IProps) {
  return (
    <div>
      <div className="w-full flex justify-between items-center pt-10 cursor-pointer">
        <p className="text-[24px] leading-8 font-bold">{title}</p>
        {isShippingAvailable && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#999999' }} onClick={onClick}>
            {'Change receiving method'} <Image src="/icons/chevron-right-gray.svg" width={16} height={16} alt="arrow-right" />
          </div>
        )}
      </div>
      <p className="text-[13px] leading-[18px] font-medium">{desc}</p>
    </div>
  );
}
